<template>
    <div class="index">
        <van-nav-bar title="红包充值" left-arrow @click-left="onClickLeft" />
        <div class="content">
            <van-field
                v-model="rechargeAmount"
                type="number"
                required
                label="充值金额"
                placeholder="请输入充值金额"
                error-message-align="right"
                input-align="right"
                :rules="[{ required: true, message: '请输入充值金额' }]"
            />

            <van-divider style="width: 90%; margin: 0 auto" />

            <van-cell required title="上传凭证">
                <div style="float: right">
                    <van-uploader
                        @oversize="onOversize"
                        :after-read="afterRead"
                        v-model="fileList"
                        :max-count="1"
                    />
                </div>
                <div
                    style="
                        color: #999;
                        font-size: var(--base-px-12);
                        float: right;
                        margin: 10px var(--base-px-14) 0;
                        display: block;
                    "
                >
                    * 请上传充值凭证图片
                </div>
            </van-cell>

            <div
                style="padding-bottom: var(--base-px-20)"
                @click="submitRecharge"
            >
                <van-button
                    :loading="loading"
                    type="info"
                    style="
                        margin: 0 auto;
                        margin-top: var(--base-px-40);
                        width: 90%;
                    "
                    block
                >
                    提交申请
                </van-button>
            </div>
            <div
                style="
                    text-decoration: underline;
                    text-align: center;
                    color: #666666;
                "
                @click="toRechargeRecord"
            >
                充值记录
            </div>
        </div>
    </div>
</template>

<script>
import { trafficRecharge, trafficUploadImage } from "../../api/traffic";

export default {
    data() {
        return {
            rechargeAmount: "",
            fileList: [],
            uploadedImage: "",
            uploadedImagePath: "",
            loading: false,
            uploadShow: "hideUpload",
            lastSubmitTime: 0, // 上次提交时间戳，用于节流
        };
    },
    methods: {
        onClickLeft() {
            this.$router.back();
        },
        // 文件大小限制
        onOversize(file) {
            this.$message.warning("文件大小不能超过 2MB");
        },
        // 上传文件
        afterRead(file) {
            // 如果是数组，取第一个
            const fileItem = Array.isArray(file) ? file[0] : file;

            fileItem.status = "uploading";
            fileItem.message = "上传中...";
            this.uploadShow = "showUpload";
            var formData = new FormData();
            formData.append("image", fileItem.file);
            trafficUploadImage(formData)
                .then((res) => {
                    console.log(res, "res");
                    if (res.code == 1) {
                        this.uploadShow = "hideUpload";
                        fileItem.status = "success";
                        fileItem.message = "上传成功";
                        this.fileList = [fileItem];
                        // 根据接口返回格式获取图片路径
                        this.uploadedImage = res.data.file_name;
                        this.uploadedImagePath = res.data.file_url;
                    } else {
                        this.uploadShow = "hideUpload";
                        fileItem.status = "failed";
                        fileItem.message = "上传失败";
                        this.$message.error("图片上传失败，请重试");
                    }
                })
                .catch((err) => {
                    this.uploadShow = "hideUpload";
                    fileItem.status = "failed";
                    fileItem.message = "上传失败";
                    this.$message.error("图片上传失败，请重试");
                });
        },
        // 提交充值申请（带节流功能）
        submitRecharge() {
            // 节流：防止重复提交，2秒内只能提交一次
            const now = Date.now();
            if (this.loading) {
                return; // 如果正在提交中，直接返回
            }
            if (now - this.lastSubmitTime < 2000) {
                return;
            }

            // 验证必填项
            if (!this.rechargeAmount) {
                this.$message.warning("请输入充值金额");
                return;
            }

            if (!this.uploadedImagePath) {
                this.$message.warning("请上传充值凭证");
                return;
            }

            // 验证金额格式
            const amount = parseFloat(this.rechargeAmount);
            if (isNaN(amount) || amount <= 0) {
                this.$message.warning("请输入有效的充值金额");
                return;
            }

            // 更新上次提交时间
            this.lastSubmitTime = now;
            this.loading = true;

            const data = {
                money: amount,
                recharge_img_url: this.uploadedImage,
            };

            trafficRecharge(data)
                .then((res) => {
                    if (res.code == 1) {
                        this.loading = false;
                        this.fileList = [];
                        this.uploadedImage = "";
                        this.uploadedImagePath = "";
                        this.rechargeAmount = "";
                        this.$message.success("充值申请提交成功");
                    } else {
                        this.loading = false;
                        this.$message.error(res.msg);
                    }
                })
                .catch((err) => {
                    this.loading = false;
                });
        },
        toRechargeRecord() {
            this.$router.push("/index/rechargeList");
        },
    },
};
</script>

<style lang="less" scoped>
.index {
    font-size: var(--base-px-14);
    height: 100%;
    background: #fff;

    .hideUpload {
        opacity: 1;
    }

    .showUpload {
        opacity: 1;
    }

    .content {
        background: #fbfbfb;
        min-height: 92%;

        .titles {
            padding: var(--base-px-5) var(--base-px-14);
            font-size: var(--base-px-14);
            color: #444;
            font-weight: bold;
            border-bottom: var(--base-px-7) solid #f2f4f8;
        }
    }
}
</style>
